import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { CalendarPlus } from 'lucide-react';
import FellowshipMeetPlanner from './FellowshipMeetPlanner';
import '../../styles/components/FellowshipMeetLauncher.css';

export default function FellowshipMeetLauncher({ group, onCreated }) {
  const [open, setOpen] = useState(false);
  const type = String(group?.groupType || group?.GroupType || '').trim().toLowerCase();
  if (!['church', 'congregation'].includes(type)) return null;

  return <>
    <button type="button" className="fellowship-meet-launch" onClick={() => setOpen(true)}>
      <CalendarPlus size={18} aria-hidden="true" /> Plan Fellowship Meet
    </button>
    <Modal show={open} onHide={() => setOpen(false)} size="lg" scrollable
      className="fellowship-planner-modal" backdropClassName="fellowship-planner-backdrop"
      aria-labelledby="fellowship-planner-title" restoreFocus>
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title id="fellowship-planner-title">Plan a Fellowship Meet</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Select churches to invite their members and founders. After saving, share the gathering’s QR code for RSVPs. The gathering will also appear on your calendar.</p>
        {open && <FellowshipMeetPlanner group={group} onCreated={onCreated} />}
      </Modal.Body>
    </Modal>
  </>;
}
